import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "60",
  height: "60",
  viewBox: "0 0 60 60"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M59.2227955,50.46875 C59.6373066,50.885419 59.8445571,51.406247 59.8445571,52.03125 C59.8445571,52.656253 59.6373066,53.177081 59.2227955,53.59375 L53.3160604,59.375 C52.9015494,59.7916687 52.4352381,60 51.9170968,60 C51.2953352,60 50.7772039,59.7916687 50.3626928,59.375 L30,38.90625 L9.63730858,59.375 C9.22279853,59.7916687 8.75648231,60 8.238345,60 C7.61658042,60 7.09845107,59.7916687 6.68394102,59.375 L0.777205894,53.59375 C0.362696144,53.177081 0.155444303,52.656253 0.155444303,52.03125 C0.155444303,51.406247 0.362696144,50.885419 0.777205894,50.46875 L21.2953384,30 L0.777205894,9.6875 C-0.259068631,8.64583 -0.259068631,7.60417 0.777205894,6.5625 L6.52850062,0.625 C7.15026519,0.20833 7.66839455,0 8.0829046,0 C8.70466917,0 9.22279853,0.20833 9.63730858,0.625 L30,20.9375 L50.3626928,0.625 C50.9844544,0.20833 51.5025858,0 51.9170968,0 C52.5388584,0 53.0569898,0.20833 53.4715008,0.625 L59.2227955,6.5625 C60.2590682,7.60417 60.2590682,8.59375 59.2227955,9.53125 L38.704663,29.84375 L59.2227955,50.46875 Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }